// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';

export const resetCustomerDetails = () => ({
    payload: getCustomerDefaultState(),
    property: 'customer',
    type: actions.UPDATE_PRODUCT_DETAILS_PRODUCT_SUCCESS
});



// WEBPACK FOOTER //
// ./src/product/details/action-creators/reset-customer-details.js